import getThemeMerger from 'util/getThemeMerger'
import { rgba } from 'polished'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiAutocomplete: {
      popupIndicatorOpen: {
        transform: 'none',
      },
      popupIndicator: {
        color: currentTheme.palette.primary.main,
      },
      endAdornment: {
        top: 'auto',
      },
      paper: {
        margin: 0,
        // To override Mui special styles for each side
        borderTop: `1px solid ${currentTheme.palette.tertiary.lightGreen}`,
        borderRight: `1px solid ${currentTheme.palette.tertiary.lightGreen}`,
        borderBottom: `1px solid ${currentTheme.palette.tertiary.lightGreen}`,
        borderLeft: `1px solid ${currentTheme.palette.tertiary.lightGreen}`,
      },
      option: {
        '&[data-focus="true"]': {
          backgroundColor: `${rgba(currentTheme.palette.tertiary.lightGreen, 0.1)}`,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-focused fieldset ': {
          border: `1px solid ${currentTheme.palette.tertiary.lightGreen} !important`,
        },
      },
    },
  },
}))
